var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EDFB9168-F6AB-4523-9E4F-54E5CEA483FA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-18.000000, -707.000000)",
    fill: "#A1ABB2",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(19.000000, 707.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1538645,18.3333693 L2.53844623,18.3333693 C2.07136448,18.3333693 1.69231075,17.9600195 1.69231075,17.5000539 L1.69231075,2.5000245 C1.69231075,2.04001967 2.07140428,1.66670913 2.53844623,1.66670913 L10.1538645,1.66670913 C10.621782,1.66670913 11,1.29422162 11,0.833393755 C11,0.372565888 10.621782,0 10.1538645,0 L2.53844623,0 C1.1389122,0 0,1.12169532 0,2.5000245 L0,17.5000147 C0,18.8783439 1.1389122,20 2.53844623,20 L10.1538645,20 C10.621782,20 11,19.6275125 11,19.1666846 C11,18.7058568 10.621782,18.3333693 10.1538645,18.3333693 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7590875,9.38968918 L14.8436502,4.2467686 C14.52673,3.91418702 14.0141825,3.91850051 13.7004943,4.25535525 C13.3868061,4.59221 13.390038,5.13478157 13.7085932,5.46736315 L17.2213308,9.14281287 L7.80844106,9.14281287 C7.36136882,9.14281287 7,9.52594685 7,9.99994614 C7,10.4739454 7.36136882,10.8571197 7.80844106,10.8571197 L17.2213308,10.8571197 L13.7085932,14.5325695 C13.390076,14.865151 13.3876426,15.4077226 13.7004943,15.7445773 C13.8589354,15.9142947 14.0675285,16 14.2761217,16 C14.4814829,16 14.6868061,15.9177213 14.8436502,15.7531237 L19.7590875,10.6102031 C19.9126996,10.4490724 20,10.2296088 20,9.99990583 C20,9.77028345 19.9134981,9.5517068 19.7590875,9.38968918 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.8886ae296fe0e8ecdd12341399948def.svg";
export { ForwardRef as ReactComponent };